// src/services/depensesrecettesclubPhotoServices.js
import axios from "axios";

// Compat Vite & CRA
const _base =
  (typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env.VITE_API_URL) ||
  process.env.REACT_APP_API_URL ||
  "";

export const baseUrl = _base.replace(/\/$/, "");

// 🔹 Tes routes serveur sont sous /api/depensesrecettesclub
const depensesBase = `${baseUrl}/api/depensesrecettesclub`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Upload/Remplace le justificatif (image/PDF) d’une dépense/recette (local sharp/pdf).
 * - POST /api/depensesrecettesclub/:id/photo?format=webp|jpg|png (défaut webp pour les images)
 * - multipart/form-data, champ "file"
 * - Réponse: { ok: true, photo_url: "/uploads/..." }
 */
export const uploadDepensesRecettesPhoto = async (
  depRecId,
  file,
  options = {}
) => {
  if (!depRecId) throw new Error("depRecId requis");
  if (!file) throw new Error("file requis");

  const { format = "webp", onUploadProgress, maxWidth } = options;

  const form = new FormData();
  form.append("file", file);

  // on peut passer maxWidth en query si besoin (géré côté contrôleur)
  const query = new URLSearchParams();
  if (format) query.set("format", String(format));
  if (typeof maxWidth === "number") query.set("maxWidth", String(maxWidth));

  try {
    const { data } = await axios.post(
      `${depensesBase}/${encodeURIComponent(
        depRecId
      )}/photo?${query.toString()}`,
      form,
      {
        headers: {
          ...authHeaders(),
          // axios gère Content-Type multipart automatiquement
        },
        onUploadProgress,
      }
    );
    return data; // { ok:true, photo_url }
  } catch (error) {
    console.error("[uploadDepensesRecettesPhoto] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

/**
 * Définir directement une URL existante comme justificatif (Cloudinary ou locale).
 * - PUT /api/depensesrecettesclub/:id/photo-url
 * - body: { photo_url: "https://..." ou "/uploads/..." }
 * - Réponse: { ok: true, photo_url }
 */
export const setDepensesRecettesPhotoUrl = async (depRecId, photo_url) => {
  if (!depRecId) throw new Error("depRecId requis");
  if (!photo_url) throw new Error("photo_url requis");
  try {
    const { data } = await axios.put(
      `${depensesBase}/${encodeURIComponent(depRecId)}/photo-url`,
      { photo_url },
      { headers: { "Content-Type": "application/json", ...authHeaders() } }
    );
    return data; // { ok:true, photo_url }
  } catch (error) {
    console.error("[setDepensesRecettesPhotoUrl] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

/**
 * Supprimer le justificatif (et le fichier local si /uploads/...).
 * - DELETE /api/depensesrecettesclub/:id/photo
 * - Réponse: { ok: true }
 */
export const deleteDepensesRecettesPhoto = async (depRecId) => {
  if (!depRecId) throw new Error("depRecId requis");
  try {
    const { data } = await axios.delete(
      `${depensesBase}/${encodeURIComponent(depRecId)}/photo`,
      { headers: { ...authHeaders() } }
    );
    return data; // { ok:true }
  } catch (error) {
    console.error("[deleteDepensesRecettesPhoto] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

/**
 * Helper pour <img src="..."> ou <a href="..."> (PDF)
 * - /uploads/... => préfixe par baseUrl (API)
 * - sinon (https://...) => renvoie tel quel
 */
export const toAbsoluteDepensesRecettesPhotoUrl = (photoUrl) => {
  if (!photoUrl) return "";
  if (photoUrl.startsWith("/uploads/")) {
    return `${baseUrl}${photoUrl}`;
  }
  return photoUrl;
};

// (Alias pratique si tu veux l’appeler "toAbsoluteJustificatifUrl")
export const toAbsoluteJustificatifUrl = toAbsoluteDepensesRecettesPhotoUrl;
